import React, { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'components/Luxkit/Typography/BodyText'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import { getFinePrintSectionIcon } from 'lib/cruises/cruiseIcons'
import Accordion from 'components/Luxkit/Accordion'

const BulletList = styled(BodyText)`
  list-style: disc;

  > * + li {
    margin-top: ${rem(16)};
  }
`

const DecimalOrderedList = styled(BodyText)`
  list-style-type: decimal;

  > * + li {
    margin-top: ${rem(16)};
  }
`

const LowerAlphaOrderedList = styled(BodyText)`
  list-style-type: lower-alpha;
  margin-bottom: 0;
  margin-top: 0;
`

interface Props {
  finePrintSection: App.CruiseFinePrintSection
}

function CruiseFinePrintSection(props: Props) {
  const { finePrintSection } = props
  const { description, items, subSections, title } = finePrintSection

  const Icon = getFinePrintSectionIcon(title)

  return (
    <Accordion
      heading={title}
      size="large"
      icon={<Icon aria-hidden="true" />}
    >
      {!!description && <BodyText variant="medium">{description}</BodyText>}
      {items.length > 0 && <BulletList forwardedAs="ul" variant="medium" weight="normal">
        {items.map((item, index) => (
          <li key={index}><MarkdownRender fontSize="medium" content={item} /></li>
        ))}
      </BulletList>}

      {subSections?.length > 0 && <DecimalOrderedList
        forwardedAs="ol"
        variant="medium"
        weight="bold"
      >
        {subSections.map((subSection, sectionIndex) => (
          <li key={sectionIndex}>
            {subSection.title}
            <LowerAlphaOrderedList
              forwardedAs="ol"
              variant="medium"
              weight="normal"
            >
              {subSection.items.map((subSectionItem, subSectionIndex) => (
                <li key={subSectionIndex}>
                  <MarkdownRender fontSize="medium" content={subSectionItem} />
                </li>
              ))}
            </LowerAlphaOrderedList>
          </li>
        ))}
      </DecimalOrderedList>}
    </Accordion>
  )
}

export default memo(CruiseFinePrintSection)
